import React, { Component } from "react";
import Header from "../components/Booking/Header";
import FormContainer from "../components/Booking/FormContainer/index";
import Helmet from "react-helmet";

class Booking extends Component {
  render() {
    const { chat, calendar, clock, noContracts, visa } = this.props.data;
    // console.log(this.props.data);
    return (
      <div>
        <Helmet>
          <title>Maid Service - Booking</title>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, maximum-scale=1"
          />
          {/* <script src="https://js.stripe.com/v3/" /> */}
        </Helmet>
        <Header
          images={this.props.data.bookingHeader.responsiveSizes}
          icons={{ chat, calendar, clock, noContracts, visa }}
        />
        <FormContainer />
      </div>
    );
  }
}

export default Booking;

export const pageQuery = graphql`
  query bookingQuery {
    bookingHeader: imageSharp(id: { regex: "/bookingheader/" }) {
      responsiveSizes {
        base64
        originalImg
      }
    }
    calendar: imageSharp(id: { regex: "/bookingCalendar/" }) {
      original {
        src
      }
    }
    clock: imageSharp(id: { regex: "/bookingClock/" }) {
      original {
        src
      }
    }
    chat: imageSharp(id: { regex: "/bookingChat/" }) {
      original {
        src
      }
    }
    noContracts: imageSharp(id: { regex: "/bookingNoContracts/" }) {
      original {
        src
      }
    }
    visa: imageSharp(id: { regex: "/bookingVisa/" }) {
      original {
        src
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/booking.jsx